import update from 'react-addons-update';
import {
  SET_MENU_SELECTED,
  SET_MENU_SELECTED_2,
  SET_MENU_FOCUS_FACILITY,
} from '../actions/menuAction';

let initialState = {
  menuSelected: '',
  menuSelected_2: '',
  focusFacility: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_SELECTED:
      return setMenuSelected(state, action);
    case SET_MENU_SELECTED_2:
      return setMenuSelected_2(state, action);
    case SET_MENU_FOCUS_FACILITY:
      return setFocusFacility(state, action);
    default:
      return { ...state };
  }
};

function setMenuSelected(state, action) {
  return update(state, { menuSelected: { $set: action.payload } });
}

function setMenuSelected_2(state, action) {
  return update(state, { menuSelected_2: { $set: action.payload } });
}

function setFocusFacility(state, action) {
  return update(state, { focusFacility: { $set: action.payload } });
}



// WEBPACK FOOTER //
// ./src/@redux/reducers/menuReducer.js